type Props = {
  src: string;
};

export default function PDF({ src }: Props) {
  return (
    <object width="100%" data={src} type="application/pdf" style={{ height: '100vh', minHeight: '100vh' }}>
      <iframe width="100%" style={{ height: '100vh', minHeight: '100vh' }} src={src}>
        <p>Unfortunately, this browser does not support PDF rendering</p>
      </iframe>
    </object>
  );
}
